import React from 'react';
import Header from '../../Layout/Header';
import Footer from '../../Layout/Footer';
import FAQ from './FAQ';
import SeoTagsFooter from './SeoTagsFooter';

function CrmSoftwareSolutions() {
  const faqs = [
    {
      question: "What is Mokshiq FinTech CRM Software?",
      answer: "Mokshiq CRM (by Rakle Service Private Limited) is a tailored Customer Relationship Management platform built specifically for Fintechs, B2B distributors, and sales teams to manage leads, retailer onboarding, and support tickets."
    },
    {
      question: "Does it integrate with WhatsApp and SMS gateways?",
      answer: "Yes, it includes built-in WhatsApp API and SMS gateway integrations for automated lead alerts and customer notifications."
    }
  ];

  return (
    <div className="page_wrapper">
      <Header />
      <main className="page_content">
        <section className="page_header text-center bg-dark section_decoration overflow-hidden py-5" style={{ backgroundImage: "url('assets/images/backgrounds/page_header_bg_1.webp')" }}>
          <div className="container">
            <span className="badge bg-warning text-dark px-3 py-2 text-uppercase mb-3 font-weight-bold" style={{ letterSpacing: '1px' }}>
              <i className="fa-solid fa-users-gear me-2"></i>Enterprise Software
            </span>
            <h1 className="page_title text-white mb-3">CRM &amp; Lead Management Software</h1>
            <p className="text-white-50 mx-auto" style={{ maxWidth: '750px' }}>
              Streamline customer onboarding, sales pipelines, and support ticket management powered by <strong>Rakle Service Private Limited</strong>.
            </p>
            <ul className="breadcrumb_nav unordered_list justify-content-center mt-3">
              <li><a href="/">Home</a></li>
              <li><a href="/services">Softwares</a></li>
              <li className="active"><a href="#!">CRM Software Solutions</a></li>
            </ul>
          </div>
        </section>

        <section className="section_space bg-white">
          <div className="container">
            <div className="row g-4">
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-filter-circle-dollar text-primary fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Lead Pipeline Tracking</h3>
                  <p className="text-muted small">Automated lead assignment, follow-up reminders, and stage conversion analytics.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-headset text-success fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Support Ticket System</h3>
                  <p className="text-muted small">Helpdesk ticketing with SLA tracking, agent assignment, and automated customer updates.</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="card h-100 p-4 border-0 shadow-sm bg-light text-center">
                  <i className="fa-solid fa-chart-line text-warning fa-3x mb-3"></i>
                  <h3 className="h5 font-weight-bold">Real-Time Analytics</h3>
                  <p className="text-muted small">Executive dashboard reporting on sales agent performance and recurring subscription revenue.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FAQ faqList={faqs} title="CRM Software FAQs" subtitle="Frequently asked questions about enterprise CRM software solutions." />
      </main>
      <Footer />
      <SeoTagsFooter />
    </div>
  );
}

export default CrmSoftwareSolutions;
